import { message } from "antd";

export const formatSavedAgo = (date: Date): string => {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  return date.toLocaleTimeString();
};

export const notifyAgentSaveSuccess = (label: string, key: string) => {
  message.success({ content: `${label} saved`, key, duration: 2 });
};
